import React, { useEffect, useMemo, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useDispatch, useSelector } from "react-redux"
import useSearch from "hooks/useSearch"
import useReportColumns from "hooks/useReportColumns"
import { REPORT_COLUMN_KEYS } from "config/reportColumnDefinitions"
import {
  exportProvinceTransactions,
  getProvinceTransactions,
} from "store/province-reports/province-report-action"
import { getProvinceItemCategories, getProvinceCurrencies } from "store/province-dashboard/province-dashboard-action"
import ProvinceTransactionListComponent from "components/ProvinceReports/Transaction"
import { getProvinceOutProvinces } from "store/province-out/province-out-action"
import { getProvinceInProjects } from "store/province-in/province-in-action"
import { getProvinceConsumptionsProviderAccount } from "store/province-consumptions/province-consumption-action"

const ProvinceTransactionList = () => {
  // Meta Title
  document.title = "Transactions"

  const dispatch = useDispatch()

  // Retrieve transactions data from Redux store
  const transactions = useSelector(
    state => state.provinceReports.provinceTransactions
  )

  // Retrieve export Transaction data from Redux store
  const exportTransaction = useSelector(
    state => state.provinceReports.provinceExportTransaction
  )
  const [search, setSearch] = useState(null)
  const [pageNumber, setPageNumber] = useState(20)
  const [according, setAccording] = useState({ order: "desc", name: "date" })
  const [advnacedSearch, setAdvancedSearch] = useState({})
  const { columns, visibleColumns, visibleKeys, toggleColumn, moveColumnToIndex } = useReportColumns(
    REPORT_COLUMN_KEYS.PROVINCE_TRANSACTION
  )


  // Updates search value when a new search is performed
  const onSearchHandler = value => {
    setSearch(value)
  }

  // Fetches new data when a page number is clicked
  const onPageClick = link => {
    dispatch(
      getProvinceTransactions(
        link.url,
        pageNumber,
        according,
        search,
        advnacedSearch
      )
    )
  }

  // Updates the number of rows displayed based on user selection (e.g., 10, 20, 50)
  const onChangeRowNumber = value => {
    setPageNumber(value)
  }

  // Updates the ordering based on user selection
  const onChangeOrdering = value => {
    if (value.order) {
      setAccording(prev => {
        return { ...prev, order: value.order }
      })
    }
    if (value.name) {
      setAccording(prev => {
        return { ...prev, name: value.name }
      })
    }
  }

  // Custom Search Hook called everytime search updates
  useSearch(
    getProvinceTransactions(
      undefined,
      undefined,
      undefined,
      search,
      advnacedSearch
    ),
    search
  )

  // fetch new data based page number or according changes
  useEffect(() => {
    dispatch(
      getProvinceTransactions(
        undefined,
        pageNumber,
        according,
        search,
        advnacedSearch
      )
    )
  }, [pageNumber, according])

  // fetch data for filter
  useEffect(() => {
    dispatch(getProvinceItemCategories())
    dispatch(getProvinceOutProvinces())
    dispatch(getProvinceInProjects())
    dispatch(getProvinceConsumptionsProviderAccount())
    dispatch(getProvinceCurrencies())
  }, [])

  // Executes when the advanced search form is submitted
  const onAdvancedSearchSubmit = data => {
    setAdvancedSearch(data)
    dispatch(
      getProvinceTransactions(undefined, undefined, undefined, search, data)
    )
  }

  // Trigger export process when Export button is clicked
  const onExportBtnClick = () => {
    dispatch(exportProvinceTransactions(pageNumber, according, search, advnacedSearch, visibleKeys))
  }

  return (
    <React.Fragment>
      <Breadcrumbs title={"Province"} breadcrumbItem={"Transactions"} />
      {/* Province Transaction List components */}
      <ProvinceTransactionListComponent
        data={transactions?.data}
        error={transactions?.error}
        loading={transactions?.loading}
        onSearch={onSearchHandler}
        onChangeRowNumber={onChangeRowNumber}
        onChangeOrdering={onChangeOrdering}
        onAdvancedSearchSubmit={onAdvancedSearchSubmit}
        onExportBtnClick={onExportBtnClick}
        exportTransaction={exportTransaction}
        onPageClick={onPageClick}
        columns={columns}
        visibleColumns={visibleColumns}
        onToggleColumn={toggleColumn}
        onReorder={moveColumnToIndex}
      />
    </React.Fragment>
  )
}

export default ProvinceTransactionList
